export async function delay(ms: number, signal?: AbortSignal) {
  return new Promise<void>((resolve, _reject) => {
    if (signal?.aborted) {
      resolve();
    }
    const timeoutId = setTimeout(resolve, ms);

    signal?.addEventListener('abort', () => {
      clearTimeout(timeoutId);
      resolve();
    });
  });
}
